import React from 'react';
import { formatNumber } from './utils';
import ModalWrapper from './ModalWrapper';

export default function StockItemActionModal({ open, item, onClose, onCheckIn, onCheckOut, onBook, onCallOff }) {
  if (!open || !item) return null;
  return (
    <ModalWrapper open={open} onClose={onClose} zIndex={40}>
      <h2 style={{color:'#1976d2',fontWeight:800,marginBottom:10,fontSize:22,letterSpacing:1}}>Stock Actions</h2>
      <div style={{background:'#f8fafc',padding:16,borderRadius:12,width:'100%',marginBottom:8}}>
        <div><b>Customer:</b> {item.client ? item.client.name : ''}</div>
        <div><b>Product Code:</b> {item.productCode}</div>
        <div><b>Description:</b> {item.mainCategory}</div>
        <div><b>Variant:</b> {item.variantDesc}</div>
        <div><b>Label Size:</b> {item.labelSize || '-'}</div>
        <div><b>Current Qty:</b> {formatNumber(item.currentQty)}</div>
        <div><b>Booked Qty:</b> {formatNumber(item.bookedQty || 0)}</div>
        <div><b>Available:</b> <span style={{color: '#2e7d32', fontWeight: 'bold'}}>{formatNumber(item.currentQty - (item.bookedQty || 0))}</span></div>
        <div><b>Min Qty:</b> {formatNumber(item.minQty)}</div>
      </div>
      {item.notes && item.notes.trim() && (
        <div style={{marginBottom:18,background:'#f1f8e9',padding:12,borderRadius:8,color:'#33691e',fontWeight:500,fontSize:15}}>
          <b>Notes:</b> {item.notes}
        </div>
      )}
      <div style={{display:'flex',gap:16,marginTop:8,flexWrap:'wrap'}}>
        {onCheckIn && (
          <button onClick={() => onCheckIn(item)} style={{background:'#43a047',color:'#fff',fontWeight:700,padding:'10px 24px',border:'none',borderRadius:8,fontSize:16,boxShadow:'0 2px 8px #1976d233'}}>Check In</button>
        )}
        <button onClick={() => onCheckOut(item)} style={{background:'#fb8c00',color:'#fff',fontWeight:700,padding:'10px 24px',border:'none',borderRadius:8,fontSize:16,boxShadow:'0 2px 8px #fb8c0033'}}>Check Out</button>
        <button onClick={() => onBook(item)} style={{background:'#1976d2',color:'#fff',fontWeight:700,padding:'10px 24px',border:'none',borderRadius:8,fontSize:16,boxShadow:'0 2px 8px #1976d233'}}>Book</button>
        {onCallOff && (
          <button onClick={() => onCallOff(item)} style={{background:'#9c27b0',color:'#fff',fontWeight:700,padding:'10px 24px',border:'none',borderRadius:8,fontSize:16,boxShadow:'0 2px 8px #9c27b033'}}>Call-off</button>
        )}
      </div>
      <button onClick={onClose} style={{marginTop:18,background:'#fff',color:'#1976d2',fontWeight:700,padding:'8px 30px',border:'1.5px solid #1976d2',borderRadius:8,fontSize:15}}>Cancel</button>
    </ModalWrapper>
  );
}
